export default "__VITE_ASSET__47183b37__"